import { render } from "./AWindow.vue?vue&type=template&id=168f02fd"
import script from "./AWindow.vue?vue&type=script&lang=js"
export * from "./AWindow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__